// ── 주문 창 입력 상태·품목 다루기 (OrderModal.jsx 326줄에서 떼어냄, 2026-10-19 — 5단계 홍보물 5-1, 300줄 규칙) ──
//   글자 그대로 옮겼다(동작 변화 0). 보낼 값 만들기는 orderPayload(form).
import { useEffect, useState } from 'react';
import { emptyOrderForm, getKstToday } from './utils';

export function useOrderForm({ open, isEdit, initialData }) {
  const [form, setForm] = useState(emptyOrderForm);

  // + 홍보물 추가 클릭 시 새 검색창 자동 포커스 트리거
  const [autoFocusNew, setAutoFocusNew] = useState(false);

  // 모달 열릴 때 폼 초기화
  useEffect(() => {
    if (!open) return;
    if (isEdit && initialData) {
      setForm({
        received_date:     initialData.received_date || getKstToday(),
        category_id:       initialData.category_id ? String(initialData.category_id) : '',
        sales_person_name: initialData.sales_person_name || '',
        company_name:      initialData.company_name || '',
        address:           initialData.address || '',
        phone:             initialData.phone || '',
        mobile_phone:      initialData.mobile_phone || '',
        courier:           initialData.courier || '',
        tracking_number:   initialData.tracking_number || '',
        memo:              initialData.memo || '',
        items: Array.isArray(initialData.items) ? initialData.items.map((i) => ({
          id:              i.id || null,
          item_id:         i.item_id || '',
          item_name:       i.item_name || '',
          quantity:        String(i.quantity || 1),
          unit_price:      i.unit_price || 0,
          courier:         i.courier || '',
          tracking_number: i.tracking_number || '',
          started_at:      i.started_at || null,
          workflow_step_id: i.workflow_step_id || null,
          checked_step_ids: i.checked_step_ids || [],
          is_ordered:      Boolean(i.is_ordered),
          ordered_by:      i.ordered_by || null,
          ordered_at:      i.ordered_at || null,
          is_cancelled:    Boolean(i.is_cancelled),
          cancelled_by:    i.cancelled_by || null,
          cancelled_at:    i.cancelled_at || null,
          no_shipping:     Boolean(i.no_shipping), // 송장불필요 여부 (마스터에서 상속)
        })) : [],
      });
    } else {
      setForm(emptyOrderForm());
    }
  }, [open, isEdit, initialData]);

  function setField(k, v) {
    setForm((p) => ({ ...p, [k]: v }));
  }

  function addItem() {
    // 새 항목을 맨 위에 추가 + 검색창 자동 포커스 트리거
    setForm((p) => ({ ...p, items: [{ id: null, item_id: '', item_name: '', quantity: '1', unit_price: 0, courier: '', tracking_number: '' }, ...p.items] }));
    setAutoFocusNew(true);
  }

  // 빠른 추가 칩 클릭 — 발주처 기본택배사·no_shipping 자동 반영
  function quickAddItem(promoItem) {
    setForm((p) => ({
      ...p,
      items: [...p.items, {
        id:              null,
        item_id:         promoItem.id,
        item_name:       promoItem.name,
        quantity:        '1',
        unit_price:      promoItem.price || 0,
        courier:         promoItem.supplier_default_courier || '',
        tracking_number: '',
        no_shipping:     Boolean(promoItem.no_shipping),
      }],
    }));
  }

  function setItem(idx, key, val) {
    setForm((p) => {
      const items = [...p.items];
      items[idx] = { ...items[idx], [key]: val };
      return { ...p, items };
    });
  }

  function selectItem(idx, found) {
    setForm((p) => {
      const items = [...p.items];
      const prev  = items[idx];
      const preservedState = {
        id:               prev.id || null,
        started_at:       prev.started_at || null,
        workflow_step_id: prev.workflow_step_id || null,
        checked_step_ids: prev.checked_step_ids || [],
        is_ordered:       Boolean(prev.is_ordered),
        ordered_by:       prev.ordered_by || null,
        ordered_at:       prev.ordered_at || null,
        is_cancelled:     Boolean(prev.is_cancelled),
        cancelled_by:     prev.cancelled_by || null,
        cancelled_at:     prev.cancelled_at || null,
      };
      if (!found) {
        // 홍보물만 초기화 — 택배사/송장번호는 유지
        items[idx] = { ...preservedState, item_id: '', item_name: '', unit_price: 0, quantity: prev.quantity || '1', courier: prev.courier || '', tracking_number: prev.tracking_number || '', no_shipping: false };
      } else {
        // 홍보물 선택 시 no_shipping·기본택배사 마스터 값 반영
        // courier: 발주처 기본택배사를 디폴트로, 이미 입력된 값이 있으면 유지
        items[idx] = {
          ...preservedState,
          item_id:         found.id,
          item_name:       found.name,
          unit_price:      found.price,
          quantity:        prev.quantity || '1',
          courier:         found.supplier_default_courier || prev.courier || '',
          tracking_number: prev.tracking_number || '',
          no_shipping:     Boolean(found.no_shipping),
        };
      }
      return { ...p, items };
    });
  }

  function removeItem(idx) {
    setForm((p) => ({ ...p, items: p.items.filter((_, i) => i !== idx) }));
  }

  return {
    form, setField, autoFocusNew, setAutoFocusNew,
    addItem, quickAddItem, setItem, selectItem, removeItem,
  };
}

export function orderPayload(form) {
  const payload = {
    received_date:     form.received_date,
    category_id:       Number(form.category_id) || null,
    sales_person_name: form.sales_person_name || null,
    company_name:      form.company_name || null,
    address:           form.address || null,
    phone:             form.phone || null,
    mobile_phone:      form.mobile_phone || null,
    memo:              form.memo || null,
    items: form.items
      .filter((i) => i.item_name)
      .map((i) => ({
        id:              i.id || null,
        item_id:         i.item_id || null,
        item_name:       i.item_name,
        quantity:        Number(i.quantity) || 1,
        unit_price:      Number(i.unit_price) || 0,
        courier:         i.courier || null,
        tracking_number: i.tracking_number || null,
      })),
  };
  return payload;
}
